/**
 * StaffManagementPresenter
 * --
 */
import { useEffect } from 'react';
import {
  Content,
  Row,
  Col,
  Descriptions,
  Text,
  // HtmlContent,
  // UploadFile,
  ModalLayout,
} from 'components';
import { Avatar, Button, Input, DatePicker, Radio } from 'antd';
import moment from 'moment';
import dayjs from 'dayjs';
import MessageAlert from 'utils';
import Formatter from 'utils/Formatter';

const StaffManagementPresenter = (props) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  const {
    data,
    selectedItem,
    modalData,
    isOpened,
    modalType,
    // files,
    onSelect,
    onChange,
    onSubmit,
    onDelete,
    onOpen,
    isRefetch,
    setIsRefetch,
  } = props;

  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  // const selectStaff = (staff) => {};
  /* ===== HOOKS ===== */
  /**
   * 데이터 수정 시 렌더링 이슈 해결
   * --
   */
  useEffect(() => {
    if (selectedItem && isRefetch) {
      const { staff_id } = selectedItem;
      // console.log(data);
      // console.log(staff_id, 'a@adsdasdasdasdass');
      let findData;

      if (staff_id) {
        findData = data?.find((staff) => staff?.staff_id === staff_id);
      }

      onSelect(findData);
      setIsRefetch(false);
    }
  }, [data, onSelect, selectedItem, isRefetch, setIsRefetch]);
  /* ===== RENDER ===== */
  // console.log(modalData);
  return (
    <>
      <Content maxWidth={'100%'} padding={0}>
        <Row>
          <Col x={6}>
            <Content maxWidth={'100%'} padding={0}>
              <Content
                maxWidth={'100%'}
                padding={0}
                backgroundColor="#FAFAFA"
                style={{ height: 800, overflow: 'auto' }}
              >
                {data?.map((_item, _index) => (
                  <div
                    key={`product_${_index}`}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      padding: 8,
                      cursor: 'pointer',
                      border:
                        selectedItem?.staff_id === _item.staff_id
                          ? '1px solid #2394E4'
                          : '1px solid #EFEFEF',
                      borderBottom:
                        selectedItem?.staff_id === _item.staff_id
                          ? '1px solid #2394E4'
                          : '1px solid #DFDFDF',
                      background:
                        selectedItem?.staff_id === _item.staff_id
                          ? 'rgba(28, 107, 244, 0.3)'
                          : '#EFEFEF',
                    }}
                    onClick={() => onSelect(_item)}
                  >
                    <div>
                      <Avatar shape="square" size={30} />
                    </div>
                    <div style={{ paddingLeft: 7 }}>
                      <Text size={12} weight={600} color={'#4E4E4E'}>
                        {_item.staff_name}
                      </Text>
                      <Text size={11} weight={500} color={'#4E4E4E'}>
                        {_item.staff_position}
                      </Text>
                    </div>
                  </div>
                ))}
              </Content>
              <div>
                <Button
                  type="primary"
                  style={{
                    width: '100%',
                    background: 'var(--primary-color)',
                    borderRadius: 0,
                  }}
                  onClick={() => onOpen(isOpened, 'staff')}
                >
                  직원 추가
                </Button>
              </div>
            </Content>
          </Col>
          <Col x={18}>
            <Content maxWidth={'100%'} padding={20}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  marginBottom: 10,
                }}
              >
                <Text size={14} weight={600} color={'#404040'}>
                  직원정보
                </Text>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <Button
                    type="primary"
                    style={{ background: 'var(--primary-color)', width: 73 }}
                    onClick={() => {
                      if (!selectedItem) {
                        MessageAlert.warning(
                          '선택된 직원이 없습니다. 편집할 직원을 선택해주세요.'
                        );
                        return;
                      }

                      onOpen(isOpened, 'staff', {
                        ...selectedItem,
                        birthday: selectedItem?.birthday
                          ? Formatter.unixToDate(
                              selectedItem?.birthday,
                              'YYYY-MM-DD'
                            )
                          : null,
                        hire_date: selectedItem?.hire_date
                          ? Formatter.unixToDate(
                              selectedItem?.hire_date,
                              'YYYY-MM-DD'
                            )
                          : null,
                        termination_date: selectedItem?.termination_date
                          ? Formatter.unixToDate(
                              selectedItem?.termination_date,
                              'YYYY-MM-DD'
                            )
                          : null,
                      });
                    }}
                  >
                    편집
                  </Button>
                  <Button
                    type="default"
                    danger={true}
                    onClick={() => {
                      if (!selectedItem) {
                        MessageAlert.warning(
                          '직원이 없습니다. 삭제처리할 직원을 선택해주세요.'
                        );
                        return;
                      }
                      window.confirm(
                        `정말 ${selectedItem?.staff_name} 을(를) 삭제처리 하시겠습니까?`
                      ) && onDelete('staff', selectedItem.staff_id);
                    }}
                  >
                    삭제
                  </Button>
                </div>
              </div>
              <Descriptions
                align="left"
                items={[
                  {
                    key: `3`,
                    label: '직원명',
                    children: `${selectedItem?.staff_name || '-'}`,
                  },
                  {
                    key: `4`,
                    label: '직원 연락처',
                    children: `${selectedItem?.staff_phone || '-'}`,
                  },
                  {
                    key: `5`,
                    label: '생년월일',
                    children: `${
                      selectedItem?.birthday
                        ? moment(
                            Formatter.unixToDate(selectedItem?.birthday)
                          ).format('YYYY.MM.DD')
                        : '-'
                    }`,
                  },
                  {
                    key: `gender`,
                    label: '성별',
                    children: `${
                      selectedItem?.staff_gender
                        ? selectedItem?.staff_gender === 'M'
                          ? '남'
                          : '여'
                        : '-'
                    }`,
                  },
                  {
                    key: `staff_position`,
                    label: '직급',
                    children: `${selectedItem?.staff_position || '-'}`,
                  },
                  {
                    key: `work_type`,
                    label: '담당업무',
                    children: `${selectedItem?.work_type || '-'}`,
                  },
                  {
                    key: `hire_date`,
                    label: '입사일',
                    children: `${
                      selectedItem?.hire_date
                        ? moment(
                            Formatter.unixToDate(selectedItem?.hire_date)
                          ).format('YYYY.MM.DD')
                        : '-'
                    }`,
                  },
                  {
                    key: `termination_date`,
                    label: '퇴사일',
                    children: `${
                      selectedItem?.termination_date
                        ? moment(
                            Formatter.unixToDate(selectedItem?.termination_date)
                          ).format('YYYY.MM.DD')
                        : '-'
                    }`,
                  },
                  {
                    key: `staff_work_time`,
                    label: '근무시간',
                    children: (
                      <div style={{ textAlign: 'left', padding: '20px 0' }}>
                        <pre>{selectedItem?.staff_work_time || '-'}</pre>
                      </div>
                    ),
                  },
                ]}
              />
            </Content>
          </Col>
        </Row>
      </Content>

      {/* 직원 추가/편집 */}
      <ModalLayout
        type="modal"
        centered
        title={'직원 추가/편집'}
        open={isOpened && modalType === 'staff'}
        onCancel={() => onOpen(isOpened)}
        closable
        width={'50%'}
        footer={
          <Content
            maxWidth={'100%'}
            padding={0}
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 10,
            }}
          >
            <Button onClick={() => onOpen(isOpened)}>닫기</Button>
            <Button
              type="primary"
              onClick={() =>
                onSubmit(
                  'staff',
                  modalData?.staff?.staff_id ? 'UPDATE' : 'CREATE'
                )
              }
            >
              저장
            </Button>
          </Content>
        }
      >
        <Content maxWidth={'100%'} padding={'30px 0px'}>
          <Row>
            <Col x={24}>
              <Content maxWidth={'100%'} padding={0}>
                <Descriptions
                  items={[
                    {
                      key: 'staff_name',
                      label: (
                        <p>
                          직원명<span style={{ color: '#F94F1A' }}>*</span>
                        </p>
                      ),
                      children: (
                        <Input
                          size="large"
                          value={modalData?.staff?.staff_name}
                          placeholder="직원명을 입력해주세요"
                          onChange={(e) =>
                            onChange('staff_name', e.target.value, 'staff')
                          }
                        />
                      ),
                    },
                    {
                      key: 'staff_phone',
                      label: '연락처',
                      children: (
                        <Input
                          size="large"
                          value={modalData?.staff?.staff_phone}
                          placeholder="연락처를 입력해주세요"
                          maxLength={13}
                          onChange={(e) =>
                            onChange(
                              'staff_phone',
                              Formatter.hyphen(e.target.value),
                              'staff'
                            )
                          }
                        />
                      ),
                    },
                    {
                      key: 'birthday',
                      label: '생년월일',
                      children: (
                        <DatePicker
                          size="large"
                          value={
                            modalData?.staff?.birthday &&
                            dayjs(modalData?.staff?.birthday)
                          }
                          placeholder="생년월일을 선택해주세요"
                          style={{ width: '100%' }}
                          onChange={(_, dateString) =>
                            onChange('birthday', dateString, 'staff')
                          }
                        />
                      ),
                    },
                    {
                      key: 'staff_gender',
                      label: '성별',
                      children: (
                        <Radio.Group
                          value={modalData?.staff?.staff_gender ?? 'M'}
                          onChange={(e) =>
                            onChange('staff_gender', e.target.value, 'staff')
                          }
                        >
                          <Radio value={'M'}>남</Radio>
                          <Radio value={'F'}>여</Radio>
                        </Radio.Group>
                      ),
                    },
                    {
                      key: 'staff_position',
                      label: '직급',
                      children: (
                        <Input
                          size="large"
                          value={modalData?.staff?.staff_position}
                          placeholder="직급을 입력해주세요"
                          maxLength={13}
                          onChange={(e) =>
                            onChange('staff_position', e.target.value, 'staff')
                          }
                        />
                      ),
                    },
                    {
                      key: 'work_type',
                      label: '담당업무',
                      children: (
                        <Input
                          size="large"
                          value={modalData?.staff?.work_type}
                          placeholder="담당업무를 입력해주세요"
                          maxLength={13}
                          onChange={(e) =>
                            onChange('work_type', e.target.value, 'staff')
                          }
                        />
                      ),
                    },
                    {
                      key: 'hire_date',
                      label: '입사일',
                      children: (
                        <DatePicker
                          size="large"
                          value={
                            modalData?.staff?.hire_date &&
                            dayjs(modalData?.staff?.hire_date)
                          }
                          placeholder="입사일을 선택해주세요"
                          style={{ width: '100%' }}
                          onChange={(_, dateString) =>
                            onChange('hire_date', dateString, 'staff')
                          }
                        />
                      ),
                    },
                    {
                      key: 'termination_date',
                      label: '퇴사일',
                      children: (
                        <DatePicker
                          size="large"
                          placeholder="퇴사일을 선택해주세요"
                          value={
                            modalData?.staff?.termination_date &&
                            dayjs(modalData?.staff?.termination_date)
                          }
                          style={{ width: '100%' }}
                          onChange={(_, dateString) =>
                            onChange('termination_date', dateString, 'staff')
                          }
                        />
                      ),
                    },
                    {
                      key: 'staff_work_time',
                      label: '근무시간',
                      span: 2,
                      children: (
                        <div style={{ padding: '20px 0px' }}>
                          <Input.TextArea
                            size="large"
                            value={modalData?.staff?.staff_work_time}
                            placeholder="설명을 입력해주세요"
                            count={{
                              show: true,
                              max: 130,
                            }}
                            style={{ minHeight: 78 }}
                            onChange={(e) =>
                              onChange(
                                'staff_work_time',
                                e.target.value,
                                'staff'
                              )
                            }
                          />
                        </div>
                      ),
                    },
                  ]}
                />
              </Content>
            </Col>
          </Row>
        </Content>
      </ModalLayout>
    </>
  );
};

export default StaffManagementPresenter;
